"use strict";

exports.__esModule = true;
exports.default = void 0;

/* istanbul ignore file */
class RouterWithIdDecorator {
  findById(id) {
    return this.routes.find(route => id === route.getId());
  }

}

exports.default = RouterWithIdDecorator;